module.exports = __webpack_public_path__ + "logo-header@2x.png?56524c24d5d41f0c9c9f73a417e74af7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-header@2x.png
// module id = 35
// module chunks = 0